import { render, staticRenderFns } from "./twitterPeople.vue?vue&type=template&id=12d75e0c"
import script from "./twitterPeople.vue?vue&type=script&lang=js"
export * from "./twitterPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports